/**
 * Handles session expiry events by redirecting to login with a toast notification
 */
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../../shared/context';
import { SESSION_EXPIRED_EVENT } from '../../shared/api/axiosInstance';

export function SessionExpiryHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('common');
  const { showWarning } = useNotification();

  useEffect(() => {
    const handleSessionExpired = () => {
      // Skip toast and redirect on public auth routes
      const publicAuthRoutes = [
        '/login',
        '/register',
        '/auth/sso/callback',
        '/verify-email',
        '/registration-pending',
        '/forgot-password',
        '/reset-password',
        '/external/', // All external portal routes
        '/pay/', // Public invoice payment page (token-driven, no JWT)
        '/sign/', // Public contract signing page (token-driven, no JWT)
      ];
      const isPublicAuthRoute = publicAuthRoutes.some(
        (route) => location.pathname === route || location.pathname.startsWith(route)
      );

      if (!isPublicAuthRoute) {
        showWarning(t('errors.sessionExpired'));
        navigate('/login', { replace: true });
      }
    };

    window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
    return () => {
      window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
    };
  }, [navigate, location.pathname, t, showWarning]);

  return null;
}
